import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'

import agent from './modules/agent'
import brands from './modules/brands'
import colors from './modules/colors'
import flaws from './modules/flaws'
import prices from './modules/prices'
import tickets from './modules/tickets'
import users from './modules/users'
import notify from './modules/notify'
import clothe from './modules/clothe'
import versions from './modules/verions'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    agent,
    brands,
    colors,
    flaws,
    prices,
    tickets,
    users,
    notify,
    clothe,
    versions
  }
  // plugins: [createPersistedState()]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js